/**
 * GA4 helpers. Consent mode v2 is initialised in public/index.html.
 * These helpers fire page_view + custom events, respecting user consent.
 */

const KEY = "iocri_consent";

export const getConsent = () => {
  try { return localStorage.getItem(KEY); } catch { return null; }
};

export const setConsent = (value) => {
  try { localStorage.setItem(KEY, value); } catch {}
  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      analytics_storage: value === "granted" ? "granted" : "denied",
    });
  }
};

export const trackPageView = (path, title) => {
  if (typeof window.gtag === "function") {
    window.gtag("event", "page_view", {
      page_path: path,
      page_title: title || document.title,
      page_location: window.location.origin + path,
    });
  }
};
